"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = ["[_nghost-%COMP%]{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column}[_nghost-%COMP%]   ng-select[_ngcontent-%COMP%]{width:100%;height:40px}[_nghost-%COMP%]   ng-select[_ngcontent-%COMP%]   .ng-control[_ngcontent-%COMP%]{height:150px;background-color:#de77a5}"];
exports.styles = styles;
